import { SearchState, SearchKnownAction, SEARCH_REQUEST, SEARCH_REQUEST_SUCCESS, SEARCH_REQUEST_FAIL } from "./types";
import { Reducer } from "react";
import { Story, HubFile } from "../../model";



const initialState: SearchState = {
    searchProgress: false,
    files: [],
    stories: [],
    error: {
        message: '',
        status: 0
    },
};



const reducer: Reducer<SearchState, SearchKnownAction> = (
    state: SearchState | undefined = initialState,
    action: SearchKnownAction,
) => {
    switch (action.type) {
        case SEARCH_REQUEST:
            return {
                ...state,
                searchProgress: true,
                files:[],
                stories: [],
            };
        case SEARCH_REQUEST_SUCCESS:
            const isFile = action.payload.filter((row) => {
                const any: any = row;
                return !any.files;
            }).length > 0;
            let files: HubFile[] = [];
            let stories: Story[] = [];
            if(isFile) {
                files = (action.payload as HubFile[]).filter(item => item.mimeType.indexOf('zip') <0 );
            } else {
                stories = (action.payload as Story[]).filter(item => item.files.length > 0);
            }
            return {
                ...state,
                searchProgress: false,
                files,
                stories
            };
        case  SEARCH_REQUEST_FAIL:
            return {
                ...state,
                searchProgress: false,
                files:[],
                stories: [],
                error: action.error
            };
        default:
            return state;
    }
};

export default reducer;